module.exports = __webpack_public_path__ + "img/effet_points_colonne_1.3122652b.png";